


























































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ComplaintResponseSvc from "@/services/ComplaintResponseService";
import { storeComplaintResponse } from "@/store/modules/ComplaintResponseStore";
import moment from "moment";

@Component
export default class ComplaintResponseForm extends Vue {
  @Prop({ default: null }) eventId!: number | null;

  storeModule = storeComplaintResponse;

  form: any = this.buildEmptyForm();
  preview: any = null;
  submitting = false;

  // Dialog state
  dialogSubmit = false;
  dialogKaUnit = false;
  dialogKomiteMutu = false;
  password = "";
  confirmAccurate = false;
  kaUnitOverrideGrading: string | null = null;
  kaUnitChangeReason = "";

  pelaporJenisOptions = [
    { text: "Pasien", value: "pasien" },
    { text: "Keluarga Pasien", value: "keluarga" },
    { text: "Pengunjung", value: "pengunjung" },
    { text: "Anonim", value: "anonim" },
  ];

  jenisKomplainOptions = [
    { text: "Lisan (loket/telepon/WA/walk-in)", value: "lisan" },
    { text: "Tertulis (surat/email/form)", value: "tertulis" },
    { text: "Media Sosial", value: "media_sosial" },
  ];

  gradingOptions = [
    { text: "MERAH", value: "merah" },
    { text: "KUNING", value: "kuning" },
    { text: "HIJAU", value: "hijau" },
  ];

  zonaOptions = [
    { text: "WIB (+07:00)", value: "wib" },
    { text: "WITA (+08:00)", value: "wita" },
    { text: "WIT (+09:00)", value: "wit" },
  ];

  rtlStatusOptions = [
    { text: "Open", value: "open" },
    { text: "In Progress", value: "in_progress" },
    { text: "Verified", value: "verified" },
    { text: "Overdue", value: "overdue" },
  ];

  penyebabList = [
    { field: "penyebab_petugas_tidak_tahu", label: "Petugas tidak mengetahui ada komplain" },
    { field: "penyebab_petugas_libur", label: "Petugas yang bertanggung jawab libur" },
    { field: "penyebab_tidak_tercatat", label: "Komplain tidak tercatat saat diterima" },
    { field: "penyebab_koordinasi_terlambat", label: "Koordinasi antar unit terlambat" },
    { field: "penyebab_butuh_investigasi", label: "Butuh investigasi lebih lanjut" },
    { field: "penyebab_manajemen_tertunda", label: "Keputusan manajemen tertunda" },
    { field: "penyebab_sistem_tidak_jalan", label: "Sistem pelaporan tidak berjalan" },
    { field: "penyebab_lainnya", label: "Lainnya" },
  ];

  rules = {
    required: (v: any) => !!v || "Wajib diisi",
    min10: (v: string) => (v && v.length >= 10) || "Minimal 10 karakter",
    min20: (v: string) => (v && v.length >= 20) || "Minimal 20 karakter",
  };

  async mounted() {
    if (this.eventId) {
      await this.storeModule.loadDetail(this.eventId);
      if (this.storeModule.currentEvent) {
        this.form = { ...this.buildEmptyForm(), ...this.storeModule.currentEvent };
        this.normalizeDateTimeFields();
        this.updatePreview();
      }
    }
  }

  buildEmptyForm() {
    return {
      id: null,
      nomor_event: null,
      tanggal_terima: moment().format("YYYY-MM-DD"),
      unit_id: "",
      unit_kode: "",
      unit_nama: "",
      petugas_penerima_nama_full: "",
      nama_pelapor: "Anonim",
      pelapor_jenis: "pasien",
      pelapor_rm: "",
      pelapor_kontak: "",
      jenis_komplain: "lisan",
      kanal_detail: "",
      grading_awal: "hijau",
      grading_final: "hijau",
      grading_change_reason: "",
      deskripsi_komplain: "",
      bukti_lampiran: [],
      t0_datetime: moment().format("YYYY-MM-DDTHH:mm"),
      t0_zona_waktu: "wib",
      t1_datetime: "",
      t1_zona_waktu: "wib",
      bukti_tindak_lanjut: [],
      penyebab_petugas_tidak_tahu: false,
      penyebab_petugas_libur: false,
      penyebab_tidak_tercatat: false,
      penyebab_koordinasi_terlambat: false,
      penyebab_butuh_investigasi: false,
      penyebab_manajemen_tertunda: false,
      penyebab_sistem_tidak_jalan: false,
      penyebab_lainnya: false,
      penyebab_lainnya_detail: "",
      rtl_korektif_jangka_pendek: "",
      rtl_preventif_jangka_menengah: "",
      rtl_pic_id: null,
      rtl_pic_nama: "",
      rtl_target_tanggal: "",
      rtl_status: "open",
      rtl_bukti_implementasi: [],
      status: "draft",
      signed_petugas_at: null,
      signed_ka_unit_at: null,
      signed_komite_mutu_at: null,
      is_locked: false,
      ka_unit_nama: null,
      komite_mutu_nama: null,
    };
  }

  normalizeDateTimeFields() {
    if (this.form.t0_datetime) {
      this.form.t0_datetime = moment(this.form.t0_datetime).format("YYYY-MM-DDTHH:mm");
    }
    if (this.form.t1_datetime) {
      this.form.t1_datetime = moment(this.form.t1_datetime).format("YYYY-MM-DDTHH:mm");
    }
  }

  get isLocked() {
    return !!this.form.is_locked;
  }

  get gradingBerubah() {
    return this.form.grading_awal && this.form.grading_final && this.form.grading_awal !== this.form.grading_final;
  }

  get needsRca() {
    return this.preview && this.preview.status_penanganan === "tidak_tercapai";
  }

  get canSubmit() {
    return this.form.t0_datetime && this.form.t1_datetime && this.form.grading_final && this.form.deskripsi_komplain;
  }

  get previewLabel() {
    if (!this.preview || !this.preview.status_penanganan) return "-";
    const m: any = {
      tercapai: "TERCAPAI",
      tidak_tercapai: "TIDAK TERCAPAI",
      belum_ditindaklanjuti: "BELUM DITINDAKLANJUTI",
    };
    return m[this.preview.status_penanganan] || "-";
  }

  get previewType() {
    if (!this.preview) return "info";
    if (this.preview.status_penanganan === "tercapai") return "success";
    if (this.preview.status_penanganan === "tidak_tercapai") return "error";
    return "warning";
  }

  get previewStatusClass() {
    if (!this.preview) return "";
    if (this.preview.status_penanganan === "tercapai") return "green--text font-weight-bold";
    if (this.preview.status_penanganan === "tidak_tercapai") return "red--text font-weight-bold";
    return "grey--text font-weight-bold";
  }

  onGradingAwalChange() {
    if (!this.form.grading_final) {
      this.form.grading_final = this.form.grading_awal;
    }
    this.updatePreview();
  }

  onGradingFinalChange() {
    this.updatePreview();
  }

  onPelaporJenisChange() {
    if (this.form.pelapor_jenis === "anonim" && !this.form.nama_pelapor) {
      this.form.nama_pelapor = "Anonim";
    }
  }

  onTimeChange() {
    if (this.form.t1_datetime && !this.form.t1_zona_waktu) {
      this.form.t1_zona_waktu = this.form.t0_zona_waktu;
    }
    this.updatePreview();
  }

  @Watch("form.grading_final")
  onGradingFinalWatch() {
    this.updatePreview();
  }

  async updatePreview() {
    if (!this.form.t0_datetime || !this.form.grading_final) {
      this.preview = null;
      return;
    }
    this.preview = await this.storeModule.previewStatus({
      grading: this.form.grading_final,
      t0: this.form.t0_datetime,
      t1: this.form.t1_datetime || undefined,
    });
  }

  // ==================== ACTIONS ====================

  async simpanDraft() {
    if (!(this.$refs.formRef as any).validate()) return;

    this.submitting = true;
    try {
      if (this.form.id) {
        await ComplaintResponseSvc.update(this.form.id, this.form);
      } else {
        const resp = await ComplaintResponseSvc.create(this.form);
        this.form = { ...this.form, ...(resp.data?.data || {}) };
        this.normalizeDateTimeFields();
      }
      this.$emit("saved");
      (this as any).$toast && (this as any).$toast.success("Berhasil disimpan");
    } catch {
      // handled in service
    }
    this.submitting = false;
  }

  openSubmitDialog() {
    if (!(this.$refs.formRef as any).validate()) return;
    this.password = "";
    this.confirmAccurate = false;
    this.dialogSubmit = true;
  }

  async doSubmit() {
    // Pastikan record sudah ada (create dulu jika belum)
    this.submitting = true;
    try {
      if (!this.form.id) {
        const resp = await ComplaintResponseSvc.create(this.form);
        this.form = { ...this.form, ...(resp.data?.data || {}) };
      }
      const resp = await ComplaintResponseSvc.submit(this.form.id, {
        ...this.form,
        password: this.password,
      });
      this.form = { ...this.form, ...(resp.data?.data || {}) };
      this.normalizeDateTimeFields();
      this.dialogSubmit = false;
      this.$emit("saved");
    } catch {
      // handled in service
    }
    this.submitting = false;
  }

  openKaUnitDialog() {
    this.password = "";
    this.kaUnitOverrideGrading = null;
    this.kaUnitChangeReason = "";
    this.dialogKaUnit = true;
  }

  async doSignKaUnit() {
    this.submitting = true;
    try {
      const payload: any = { password: this.password };
      if (this.kaUnitOverrideGrading && this.kaUnitOverrideGrading !== this.form.grading_final) {
        payload.grading_final_override = this.kaUnitOverrideGrading;
        payload.grading_change_reason = this.kaUnitChangeReason;
      }
      await ComplaintResponseSvc.signKaUnit(this.form.id, payload);
      this.dialogKaUnit = false;
      if (this.form.id) {
        await this.storeModule.loadDetail(this.form.id);
        this.form = { ...this.form, ...(this.storeModule.currentEvent || {}) };
        this.normalizeDateTimeFields();
      }
      this.$emit("saved");
    } catch {
      // handled in service
    }
    this.submitting = false;
  }

  openKomiteMutuDialog() {
    this.password = "";
    this.dialogKomiteMutu = true;
  }

  async doSignKomiteMutu() {
    this.submitting = true;
    try {
      await ComplaintResponseSvc.signKomiteMutu(this.form.id, { password: this.password });
      this.dialogKomiteMutu = false;
      if (this.form.id) {
        await this.storeModule.loadDetail(this.form.id);
        this.form = { ...this.form, ...(this.storeModule.currentEvent || {}) };
        this.normalizeDateTimeFields();
      }
      this.$emit("saved");
    } catch {
      // handled in service
    }
    this.submitting = false;
  }

  printPdf() {
    if (this.form.id) ComplaintResponseSvc.printPdf(this.form.id);
  }

  // ==================== FORMATTERS ====================

  formatDateTime(val: string) {
    return val ? moment(val).format("DD/MM/YYYY HH:mm") : "-";
  }

  formatDurasi(menit: number | null, grading: string) {
    if (menit === null || menit === undefined) return "-";
    if (grading === "merah") {
      const jam = Math.floor(menit / 60);
      const sisa = menit % 60;
      return jam > 0 ? `${jam} jam ${sisa} menit` : `${sisa} menit`;
    }
    return `${menit} menit`;
  }

  gradingColor(val: string) {
    const m: any = { merah: "#D32F2F", kuning: "#F9A825", hijau: "#388E3C" };
    return m[val] || "grey";
  }

  gradingLabel(val: string) {
    const m: any = { merah: "MERAH", kuning: "KUNING", hijau: "HIJAU" };
    return m[val] || "-";
  }

  gradingBatas(val: string) {
    const m: any = {
      merah: "≤ 1×24 jam",
      kuning: "≤ 3 hari kerja",
      hijau: "≤ 7 hari kerja",
    };
    return m[val] || "-";
  }
}
